import { createComponent } from '@carvana/merch-components';
import cx from 'classnames';
import Fire from '~/icons/FireIcon';
import {
  ElementWithLoading,
  LoadingProps
} from '../SptPriceDetailsContent.styles';

export const Wrapper = createComponent('div', {
  className: 'grid justify-items-center gap-24 m:auto-cols-fr m:grid-flow-col'
});

export const Card = createComponent<LoadingProps>(
  ElementWithLoading,
  props => ({
    className: cx(
      'relative flex w-full flex-col rounded-md border border-grey-2 bg-white',
      props.isLongCard ? 'max-w-[680px] m:w-[680px]' : 'max-w-[448px]'
    ),
    'data-qa': 'common-card'
  })
);

export const CardHeader = createComponent('div', {
  className: 'flex flex-col gap-xl border-b border-grey-2 p-2xl text-blue-6',
  'data-qa': 'card-header'
});

export const Title = createComponent('h1', {
  className: 'border-b border-grey-2 py-16 text-center text-blue-6 tl-header-xl'
});

export const Contents = createComponent('div', {
  className: 'flex h-full flex-1 flex-col p-32'
});

export const PriceSection = createComponent('div', {
  className: 'border-b border-grey-2 pb-24 text-center'
});

export const Price = createComponent('p', {
  className: 'font-bold text-blue-6 tl-header-xxl -:mb-8'
});

export const MonthlyPayment = createComponent('span', {
  className: 'font-bold text-blue-6 tl-header-xxl'
});

export const PriceBreakDown = createComponent('ul', {
  className: 'my-16 text-blue-6'
});

export const LineItem = createComponent('li', {
  className: 'flex justify-between tl-body-m -:mb-8'
});

export const SummaryLineItem = createComponent('li', {
  className: 'flex justify-between tl-header-s -:mb-8'
});

export const ButtonWrapper = createComponent('div', {
  className: 'flex flex-1 items-end'
});

export const MonthlyDetails = createComponent('div', {
  className: 'mt-16 grid justify-items-center gap-16 text-center'
});

export const PayMonthlyCopy = createComponent('p', {
  className: 'text-blue-6 tl-body-m'
});

export const FireIcon = createComponent(Fire, {
  className: 'mr-8 h-16 w-16'
});
